import { memo } from 'react';
import PropTypes from 'prop-types';
import TagsCategory from '../../tagsCategory';

const VirtualTagCategory = ({ translations, category, onSelectTag }) => {
  return (
    <TagsCategory
      translations={translations}
      category={category}
      onSelectTag={onSelectTag}
      isTagSelectable
      isSmallCategoryBox
    />
  );
};

VirtualTagCategory.propTypes = {
  translations: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
  onSelectTag: PropTypes.func.isRequired,
};

export default memo(VirtualTagCategory);
